(function () {
  'use strict';

  var header;
  var statusQueue = [];
  var announcing = false;

  function updateHeaderHeight() {
    var bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--storefront-header-height', (bottom + 12) + 'px');
    return bottom;
  }

  function focusAndReveal(target) {
    target.focus({ preventScroll: true });
    function reveal() {
      if (document.activeElement !== target) return;
      var top = target.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: Math.max(0, top - updateHeaderHeight() - 12), behavior: 'instant' });
    }
    reveal();
    // Scrolling upward expands the header over 300ms. Correct at transition end,
    // not just the next frame, so the destination remains below the expanded rows.
    if (header) header.addEventListener('transitionend', reveal);
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(reveal);
    });
    window.setTimeout(function () {
      reveal();
      if (header) header.removeEventListener('transitionend', reveal);
    }, 550);
  }

  function nextAnnouncement() {
    var status = document.getElementById('storefront-status');
    if (!status || !statusQueue.length) {
      announcing = false;
      return;
    }
    announcing = true;
    status.textContent = '';
    // Separate clearing and setting so adding the same item twice is announced twice.
    window.setTimeout(function () {
      status.textContent = statusQueue.shift();
      window.setTimeout(nextAnnouncement, 1800);
    }, 100);
  }

  function announce(message) {
    if (!message) return;
    statusQueue.push(message);
    if (!announcing) {
      announcing = true;
      // Cart rendering moves focus to the drawer before the polite announcement.
      window.setTimeout(nextAnnouncement, 600);
    }
  }

  function visible(element) {
    return element.getClientRects().length > 0 && !element.closest('[hidden], [inert]');
  }

  function firstProduct(container) {
    return Array.from(container.querySelectorAll(
      '#searchspring-content .ss__result a[href*="/products/"], ' +
      '.boost-pfs-filter-products a[href*="/products/"], ' +
      '#bc-sf-filter-products a[href*="/products/"]'
    )).find(visible);
  }

  function patchProductSkips() {
    if (!document.body.classList.contains('template-collection')) return;
    document.querySelectorAll('#searchspring-sidebar, .boost-pfs-filter-tree-v, #bc-sf-filter-tree').forEach(function (filters) {
      var container = filters.closest('.collection_product_grid, .collection, .shopify-section') || filters.parentElement.parentElement;
      if (container.querySelector('.skip-to-products')) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'skip-to-products';
      button.textContent = 'Skip to products';
      filters.parentNode.insertBefore(button, filters.parentNode.firstChild);
      button.addEventListener('click', function () {
        // Resolve on activation: Searchspring/Boost replace cards after filtering.
        var product = firstProduct(container);
        if (product) focusAndReveal(product);
        else announce('No products are currently available. Please wait for products to load or change your filters.');
      });
    });
  }

  var cookieSelector = '.pd-floating-icon__open, .pd-floating-text__open';
  var startup = true;
  var lastFocus = null;
  var lastScroll = { x: window.scrollX, y: window.scrollY };

  function allowCookieFocus(event) {
    if (!event.isTrusted) return;
    startup = false;
  }
  ['keydown', 'pointerdown', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, allowCookieFocus, { capture: true, passive: true });
  });
  window.addEventListener('scroll', function () {
    if (!document.activeElement || !document.activeElement.matches(cookieSelector)) {
      lastScroll = { x: window.scrollX, y: window.scrollY };
    }
  }, { passive: true });
  document.addEventListener('focusin', function (event) {
    if (!event.target.matches(cookieSelector)) {
      lastFocus = event.target;
      return;
    }
    // Suppress only unsolicited startup focus. Tab, clicks, and dialog returns work normally.
    if (!startup) return;
    if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
    else event.target.blur();
    window.scrollTo({ left: lastScroll.x, top: lastScroll.y, behavior: 'instant' });
  }, true);

  function patchCookieControl() {
    document.querySelectorAll(cookieSelector).forEach(function (button) {
      button.removeAttribute('autofocus');
      var widget = button.closest('.cc-revoke');
      var skip = document.querySelector('.skip-to-main-content-link');
      // Pandectes prepends its reopen control. Keep the skip link first in reading order.
      // Move once; don't repeatedly move a focused widget or an open consent dialog.
      if (widget && skip && !widget.dataset.storefrontOrdered &&
          (widget.compareDocumentPosition(skip) & Node.DOCUMENT_POSITION_FOLLOWING)) {
        widget.dataset.storefrontOrdered = 'true';
        document.body.appendChild(widget);
      }
    });
  }

  function requestItems(data) {
    if (typeof data === 'string') {
      try { return requestItems(JSON.parse(data)); } catch (error) { /* Form-encoded request. */ }
      var params = new URLSearchParams(data);
      var items = [];
      params.forEach(function (value, key) {
        var match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (match) {
          var index = Number(match[1]);
          if (!items[index]) items[index] = {};
          items[index][match[2]] = value;
        }
      });
      return items.length ? items : [{ id: params.get('id'), quantity: params.get('quantity') || 1 }];
    }
    return data && (data.items || [data]) || [];
  }

  function hookCartSuccess() {
    if (!window.jQuery) return;
    window.jQuery(document).on('ajaxSuccess.storefrontA11y', function (event, xhr, settings, response) {
      var url;
      try { url = new URL(settings.url, window.location.href); } catch (error) { return; }
      if (url.origin !== window.location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname) ||
          String(settings.type).toUpperCase() !== 'POST') return;
      var requested = requestItems(settings.data);
      var added = response && (response.items || [response]);
      if (!added) return;
      added.forEach(function (item, index) {
        var request = requested.find(function (candidate) {
          return candidate && String(candidate.id) === String(item.variant_id || item.id);
        }) || requested[index];
        var quantity = Number(request && request.quantity || 1);
        var title = item.product_title || item.title;
        if (quantity > 0 && title) announce(quantity + ' ' + title + ' added to cart');
      });
    });
  }

  function quoteTitle(productId) {
    var buttons = Array.from(document.querySelectorAll('[scr-pid]'));
    var button = buttons.find(function (element) { return element.getAttribute('scr-pid') === String(productId); });
    var card = button && button.closest('[data-name], .product-card-wrapper, .ss__result, .product-card');
    if (card) {
      var heading = card.querySelector('h2, h3, h4, .card-title, .ss__result__title');
      return card.getAttribute('data-name') || (heading && heading.textContent.trim());
    }
    if (window.ProductPage && window.ProductPage.product && String(window.ProductPage.product.id) === String(productId)) {
      return window.ProductPage.product.title;
    }
    if (document.body.classList.contains('template-product')) {
      var heading = document.querySelector('#main_content_wrapper h1');
      return heading && heading.textContent.trim();
    }
    return null;
  }

  function hookQuoteSuccess() {
    var app = window.sc_raq_app_global;
    if (!app || typeof app.add_item_to_list !== 'function' || app.add_item_to_list.storefrontA11y) return;
    var original = app.add_item_to_list;
    function addItem(variantId, quantity, productId) {
      var title = quoteTitle(productId);
      var result = original.apply(this, arguments);
      // YouQuote returns true only after successfully saving its quote list.
      if (result === true && title && Number(quantity) > 0) announce(quantity + ' ' + title + ' added to quote');
      return result;
    }
    addItem.storefrontA11y = true;
    app.add_item_to_list = addItem;
  }

  document.addEventListener('click', function (event) {
    var skip = event.target.closest('.skip-to-main-content-link');
    if (skip) {
      var main = document.getElementById('main_content_wrapper');
      if (main) {
        event.preventDefault();
        focusAndReveal(main);
      }
    }
    // Some app versions finish initialization after DOMContentLoaded.
    hookQuoteSuccess();
  }, true);

  function patchDynamicContent() {
    patchProductSkips();
    patchCookieControl();
    hookQuoteSuccess();
  }

  function init() {
    header = document.querySelector('.global-header');
    updateHeaderHeight();
    if (header && window.ResizeObserver) new ResizeObserver(updateHeaderHeight).observe(header);
    window.addEventListener('resize', updateHeaderHeight);
    hookCartSuccess();
    patchDynamicContent();
    // A few existing add handlers reload the page immediately after success.
    try {
      var pending = JSON.parse(window.sessionStorage.getItem('storefront-add-announcements') || 'null');
      window.sessionStorage.removeItem('storefront-add-announcements');
      if (pending && Date.now() - pending.time < 30000) pending.messages.forEach(announce);
    } catch (error) { /* Announcements still work when storage is unavailable. */ }
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        patchDynamicContent();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('beforeunload', function () {
    if (!statusQueue.length) return;
    try {
      window.sessionStorage.setItem('storefront-add-announcements', JSON.stringify({ time: Date.now(), messages: statusQueue }));
    } catch (error) { /* Storage may be disabled by the visitor. */ }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
